import { ReactElement, useState } from 'react';

import { Headline } from 'components/Headline';

import * as S from './Tooltip.styles';

type TooltipProps = {
  text: string;
  children?: ReactElement | string;
};

const defaultProps: Partial<TooltipProps> = {};

export function Tooltip(props: TooltipProps): React.ReactElement {
  const { text, children } = { ...defaultProps, ...props };

  const [isVisible, isVisibleSet] = useState(false);

  return (
    <S.Container onMouseOver={() => isVisibleSet(true)} onMouseOut={() => isVisibleSet(false)}>
      {children ? <S.ChildContainer>{children}</S.ChildContainer> : null}

      {isVisible && (
        <S.Tooltip>
          <Headline scale="xs" color="white" fontFamily="LFT Zeno">
            {text}
          </Headline>
          <S.Arrow />
        </S.Tooltip>
      )}
    </S.Container>
  );
}
